import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { ConfirmZipPayslipUploadResponse } from "../request/ZipPayslipUploadRequest";

interface ConfirmArgs {
  jobId: number;
}

const ConfirmZipPayslipUploadApiService = async ({
  jobId,
}: ConfirmArgs): Promise<ConfirmZipPayslipUploadResponse> => {
  const { data } = await axios.post<ConfirmZipPayslipUploadResponse>(
    `/v1/employer/payslip-batches/${jobId}/confirm/`,
    {}
  );
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useConfirmZipPayslipUploadApiService = () =>
  useMutation<ConfirmZipPayslipUploadResponse, AxiosError, ConfirmArgs>(
    ConfirmZipPayslipUploadApiService,
    {
      mutationKey: ["ConfirmZipPayslipUploadApiService"],
    }
  );

export default useConfirmZipPayslipUploadApiService;
